import axios from "axios";
import { servicePath } from "../../constants/defaultValues";
import cookie from "js-cookie";

const urlParams = new URLSearchParams(window.location.search);
const utm_source_param = urlParams.get("utm_source");

if (utm_source_param) {
  cookie.set("utm_source", utm_source_param, {
    expires: 7,
  });
}

let header;
if (utm_source_param) {
  header = {
    "Content-Type": "application/json",
    "DEVICE-TYPE": "web_app",
    REFERRER: utm_source_param,
  };
} else {
  header = {
    "Content-Type": "application/json",
    "DEVICE-TYPE": "web_app",
  };
}

const instance = axios.create({
  // baseURL: servicePath + "/api/v1/,
  // baseURL: servicePath + "/api/v2/",
  // baseURL: servicePath + "/api/v3/",
  // baseURL: servicePath + "/api/v4/",
  // baseURL: servicePath + "/api/v5/",
  // baseURL: servicePath + "/api/v6/",
  // baseURL: servicePath + "/api/v7/",
  baseURL: servicePath + "/api/v8/",

  headers: header,
});

// Keep AUTH-TOKEN in sync; always identify as web so device bind matches login.
instance.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  if (!config.headers["DEVICE-TYPE"] && !config.headers["device-type"]) {
    config.headers["DEVICE-TYPE"] = "web_app";
  }
  const token = localStorage.getItem("token");
  if (token && !config.headers["AUTH-TOKEN"] && !config.headers["auth-token"]) {
    config.headers["AUTH-TOKEN"] = token;
  }
  return config;
});
// const instance1 = axios.create({
//   // baseURL: servicePath + "/api/v1/,
//   // baseURL: servicePath + "/api/v2/",
//   // baseURL: servicePath + "/api/v3/",
//   // baseURL: servicePath + "/api/v4/",
//   // baseURL: servicePath + "/api/v5/",
// });

export default instance;
